import React from 'react';
import * as styles from './QualityAssessmentTemplate.module.scss';
import { Button, IconList } from 'components/core';
import { IsolationPage, TemplateToolInfo } from 'components/shared';
import {
  EXTRACTION_STUDIES_LIST_ROUTE,
  QUALITY_ASSESSMENT_CUSTOM_TEMPLATE_CREATE_ROUTE,
  tokenizeRoute,
  getChooseYourTemplateBackRoute,
} from 'query/routes';
import { getReviewId } from 'query/review';
import {
  QualityAssessmentTemplate as QualityAssessmentTemplateType,
  QualityAssessmentTemplateFormat,
} from 'types/DataExtraction';

export type QualityAssessmentTemplateState = QualityAssessmentTemplateType;

const QualityAssessmentTemplate = () => {
  const reviewId = getReviewId();
  const urlParams = new URLSearchParams(window.location.search);
  const backToParam = urlParams.get('backTo');
  const typeParam = urlParams.get('type') as 'de' | 'qa' | null;
  const skipSelectorParam = urlParams.get('skipSelector') === 'true';

  const backRoute = backToParam
    ? getChooseYourTemplateBackRoute({
        reviewId,
        type: typeParam ?? 'qa',
        backTo: backToParam,
        skipSelector: skipSelectorParam,
      })
    : tokenizeRoute(EXTRACTION_STUDIES_LIST_ROUTE, {
        review_id: reviewId,
      });

  return (
    <IsolationPage
      back={backRoute}
      title={
        <TemplateToolInfo
          title="Quality assessment template"
          subTitle="Extraction 1"
          icon={IconList.light.faTableList}
        />
      }
    >
      <div className={styles.QualityAssessmentTemplate}>
        <div>
          <Button
            to={tokenizeRoute(QUALITY_ASSESSMENT_CUSTOM_TEMPLATE_CREATE_ROUTE, {
              review_id: reviewId,
              initial_format: QualityAssessmentTemplateFormat.ROB,
              ...(backToParam && { backTo: backToParam }),
              ...(typeParam && { type: typeParam }),
            })}
            type="brand"
          >
            Cochrane RoB1 template
          </Button>
          <Button
            to={tokenizeRoute(QUALITY_ASSESSMENT_CUSTOM_TEMPLATE_CREATE_ROUTE, {
              review_id: reviewId,
              initial_format: QualityAssessmentTemplateFormat.EMPTY,
              ...(backToParam && { backTo: backToParam }),
              ...(typeParam && { type: typeParam }),
            })}
            type="brand"
          >
            Custom template
          </Button>
        </div>
      </div>
    </IsolationPage>
  );
};

export default QualityAssessmentTemplate;
